import React from 'react'
import GitHubCalendar from 'react-github-calendar';

import ReactTooltip from 'react-tooltip';


import "./gitcalender.css"



export default function Gitstackcalender() {

    const selectLastFullYear  = (contributions) => {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();
        const shownMonths =4;
      
        return contributions.filter(day => {
          const date = new Date(day.date);
          const monthOfDay = date.getMonth();
      
          return (
            date.getFullYear() === currentYear &&
            monthOfDay > currentMonth - shownMonths &&
            monthOfDay <= currentMonth
          );
        });
     
      };


  return (

    <div  >

  <h1 className='githeading'>Git-Calendar</h1>

    
    <div  className="gitcalender">
    <GitHubCalendar 
     
   
      
   
   
    
     username="gurjazz18" 
     transformData={selectLastFullYear } 
      hideColorLegend
      hideTotalCount
      blockSize={20}
   >

    <ReactTooltip delayShow={20}/>

   </GitHubCalendar>

      </div>
   


    
   

      
    </div>
  )
}
